import { useState } from "react";

export default function AdminCreateClient() {
    const [form, setForm] = useState({
        firstname: "",
        lastname: "",
        phone: "",
        email: "",
    });

    const [products, setProducts] = useState([]); // ← empty by default


    const [status, setStatus] = useState(null);

    const removeProduct = (index) => {
        const updated = [...products];
        updated.splice(index, 1);
        setProducts(updated);
    };


    const handleClientChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleProductChange = (index, e) => {
        const { name, value } = e.target;
        const updated = [...products];
        updated[index][name] = value;
        setProducts(updated);
    };

    const addProduct = () => {
        setProducts([...products, { website: "", description: "" }]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus(null);

        try {
            // 1. Create the client
            const res = await fetch("/api/clients", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });

            const data = await res.json();
            if (!res.ok) throw new Error(data.message || "Client creation failed");

            const clientId = data.result.lastInsertRowid;

            // 2. Add each product (only if at least one product is filled)
            const validProducts = products.filter(p => p.website.trim() !== "");

            for (const product of validProducts) {
                await fetch("/api/products", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ ...product, client_id: clientId }),
                });
            }


            setStatus({ success: true, message: "Client and products added!" });
            setForm({ firstname: "", lastname: "", phone: "", email: "" });
            setProducts([{ website: "", description: "" }]);
        } catch (err) {
            setStatus({ success: false, message: err.message });
        }
    };

    return (
        <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-lg p-6 sm:p-10">
            <h2 className="text-xl font-bold text-[#785f14] mb-6 text-center">
                Create New Client
            </h2>

            <form onSubmit={handleSubmit} className="space-y-6">
                {/* Client Inputs */}
                {["firstname", "lastname", "phone", "email"].map((field) => (
                    <label key={field} className="block text-sm font-medium text-gray-700">
                        {field.charAt(0).toUpperCase() + field.slice(1)}
                        <input
                            type={field === "email" ? "email" : "text"}
                            name={field}
                            value={form[field]}
                            onChange={handleClientChange}
                            className="mt-1 block w-full px-4 py-2 border rounded-lg"
                            required
                        />
                    </label>
                ))}

                {/* Product Inputs */}
                <div>
                    <h3 className="font-semibold text-sm text-gray-800 mb-2">Products</h3>

                    {products.length === 0 ? (
                        <button
                            type="button"
                            onClick={() => setProducts([{ website: "", description: "" }])}
                            className="text-blue-600 text-sm"
                        >
                            + Add a product
                        </button>
                    ) : (
                        <>
                            {products.map((product, idx) => (
                                <div
                                    key={idx}
                                    className="grid grid-cols-1 sm:grid-cols-[1fr_1fr_1fr_auto] gap-4 mb-4 items-start"
                                >
                                    <input
                                        type="text"
                                        placeholder="Website URL"
                                        name="website"
                                        value={product.website}
                                        onChange={(e) => handleProductChange(idx, e)}
                                        required
                                        className="px-4 py-2 border rounded-lg"
                                    />
                                    <input
                                        type="text"
                                        placeholder="Description"
                                        name="description"
                                        value={product.description}
                                        onChange={(e) => handleProductChange(idx, e)}
                                        className="px-4 py-2 border rounded-lg"
                                    />
                                    <input
                                        type="number"
                                        placeholder="Monthly Price ($)"
                                        name="monthly_price"
                                        value={product.monthly_price}
                                        onChange={(e) => handleProductChange(idx, e)}
                                        className="px-4 py-2 border rounded-lg"
                                        min="0"
                                        step="0.01"
                                    />

                                    <button
                                        type="button"
                                        onClick={() => removeProduct(idx)}
                                        className="text-red-500 text-sm hover:underline mt-2 sm:mt-0"
                                    >
                                        Remove
                                    </button>
                                </div>
                            ))}


                            <button type="button" onClick={addProduct} className="text-blue-600 text-sm">
                                + Add another product
                            </button>
                        </>
                    )}
                </div>


                {/* Status */}
                {status && (
                    <p className={`text-sm ${status.success ? "text-green-600" : "text-red-500"}`}>
                        {status.message}
                    </p>
                )}

                {/* Submit */}
                <button
                    type="submit"
                    className="w-full px-6 py-2.5 rounded-lg bg-gradient-to-r from-brand to-brand-hover text-white font-medium"
                >
                    Submit
                </button>
            </form>
        </div>
    );
}
